import { useColorScheme, Box } from "@mui/material";
import { Constants } from "../../utils/constants";

export default function BorderWidget(props) {
  const { children, sx } = props;
  const { mode } = useColorScheme();
  return (
    mode && <Box
      sx={{
        border: "1px solid",
        borderColor: Constants.Colors[mode].border,
        borderRadius: "8px",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}